<script setup lang="ts">
import { computed, ref } from 'vue'
import CreateBankAccountModal from '../partials/CreateBankAccountModal.vue'
import BuyerConfirmSection from './sections/BuyerConfirmSection.vue'
import SellerConfirmSection from './sections/SellerConfirmSection.vue'

const props = defineProps({
  modelValue: Boolean,
  transaction: {
    type: Object,
  },
  buyerIranianSrc: { type: Array },
  buyerIranian: { type: Array },
  buyerRevolut: { type: Array },
  buyerPaypal: { type: Array },
  buyerInternational: { type: Array },
  buyerWise: { type: Array },
  sellerIranianSrc: { type: Array },
  sellerIranian: { type: Array },
  sellerRevolut: { type: Array },
  sellerPaypal: { type: Array },
  sellerInternational: { type: Array },
  sellerWise: { type: Array },
})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

const accountType = ref('')
const internationalType = ref<string | null>('')
const userIdForCreateAccount = ref<number | undefined>(undefined)

const isCreateAccountModalOpen = ref(false)

const closeModal = () => {
  emit('update:modelValue', false)
  emit('cancel')
}

const verifiedSellerIranianSrc = computed(() =>
  (props.sellerIranianSrc ?? []).map((account: any) => ({
    ...account,
    disabled: !account.verified,
  }))
)

const verifiedSellerIranian = computed(() =>
  (props.sellerIranian ?? []).map((account: any) => ({
    ...account,
    disabled: !account.verified,
  }))
)

const verifiedBuyerIranianSrc = computed(() =>
  (props.buyerIranianSrc ?? []).map((account: any) => ({
    ...account,
    disabled: !account.verified,
  }))
)

const verifiedBuyerIranian = computed(() =>
  (props.buyerIranian ?? []).map((account: any) => ({
    ...account,
    disabled: !account.verified,
  }))
)

const handleCreateAccountConfirm = () => {
  console.log('Confirmed create new account')
  isCreateAccountModalOpen.value = false
}

const openCreateAccountModal = (accountTypeValue: string, internationalTypeValue: string | null, isBuyer: boolean) => {
  accountType.value = accountTypeValue
  internationalType.value = internationalTypeValue
  isCreateAccountModalOpen.value = true

  userIdForCreateAccount.value = isBuyer ? props.transaction?.buyer?.uuid : props.transaction?.seller?.uuid
}

const resetAccountTypes = () => {
  accountType.value = ''
  internationalType.value = ''
}

const handleChildConfirm = () => {
  emit('confirm')
  closeModal()
}
</script>

<template>
  <Modal :model-value="props.modelValue && !isCreateAccountModalOpen"
    @update:model-value="$emit('update:modelValue', $event)" @click.stop="" width="600px" background="#FFF"
    :closable="!isCreateAccountModalOpen" title="تایید طرفین" closeDirection="left" class="update-request"
    :style="{ pointerEvents: isCreateAccountModalOpen ? 'none' : 'auto' }">

    <form class="flex flex-col h-[600px]">

      <div class="flex-1  px-4 py-6 pb-9 space-y-2">

        <div class="">
          <!--  _________________________ BUYER  _________________________  -->
          <BuyerConfirmSection :transaction="transaction" :buyer-iranian-src="verifiedBuyerIranianSrc"
            :buyer-iranian="verifiedBuyerIranian" :buyer-revolut="buyerRevolut" :buyer-paypal="buyerPaypal" :buyer-wise="buyerWise"
            :buyer-international="buyerInternational" @accept="handleChildConfirm" @reject="handleChildConfirm"
            @create-account="(accountType, internationalType, isBuyer) => openCreateAccountModal(accountType, internationalType, isBuyer)" />

          <!--  _________________________ SELLER  _________________________ -->
          <SellerConfirmSection :transaction="transaction" :seller-iranian-src="verifiedSellerIranianSrc"
            :seller-iranian="verifiedSellerIranian" :seller-revolut="sellerRevolut" :seller-paypal="sellerPaypal" :seller-wise="sellerWise"
            :seller-international="sellerInternational" @accept="handleChildConfirm" @reject="handleChildConfirm"
            @create-account="(accountType, internationalType, isBuyer) => openCreateAccountModal(accountType, internationalType, isBuyer)" />
        </div>

      </div>

      <div class="sticky bottom-0 bg-white z-50 flex justify-between gap-6 w-full pt-3 pb-9 px-2  border-gray-200">
        <Button type="button" @click="closeModal" variant="outline" label="بازگشت" :isAdmin="true"
          class="w-full  h-12 rounded-xl border-2" />
      </div>
    </form>
  </Modal>
  <CreateBankAccountModal v-model="isCreateAccountModalOpen" :userId="userIdForCreateAccount"
    :UserAccountType="accountType" :UserInternationalType="internationalType ?? ''"
    @confirm="handleCreateAccountConfirm" @cancel="() => { isCreateAccountModalOpen = false; resetAccountTypes(); }"
    @click.stop="" />
</template>
